/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, useState } from "react";
import { Link } from "@reach/router";
import { Form, Button } from 'react-bootstrap';

import useLogin from "../providers/use_login";
import WikiNavBar from "../components/navbar";
import Login from "../components/login";
// import LogViewer from "../components/log_viewer";
import Footer from "../components/footer";
import Loading from "../components/loading";

const MiCuentaPage = () => {
  const { token, user, isReady, logout } = useLogin();
  const [matchError, setMatchError] = useState(null)
  const [newPassError, setNewPassError] = useState(null)

  const handleSubmit = (e) => {
    e.preventDefault()
    const { password, newPassword, repitePassword } = e.target.elements
    console.log(e.target.elements)
    if (newPassword?.value !== repitePassword?.value) {
      setMatchError('Las contraseñas no coinciden')
    } else setMatchError(null)
    if (newPassword?.value?.length < 6) {
      setNewPassError('La contraseña debe contener al menos 6 caracteres')
    } else setNewPassError(null)
    // login(e.target.elements.email.value, e.target.elements.password.value, onSuccess)
    alert('Esta función se encuentra aún en desarrollo. Pronto estará disponible!')
  }

  const error = null

  if (!isReady) return <Fragment>
    <WikiNavBar />
    <Loading />
  </Fragment>

  if (!token)
    return (
      <Fragment>
        <WikiNavBar />
        <div style={{ marginTop: 55 }} />
        <Login />
      </Fragment>
    );

  if (user && user.activo) return (
    <Fragment>
      <WikiNavBar />
      <div className="container">
        <div style={{ height: 20 }} />
        <h2>Mi Cuenta</h2>
        <p>
          Sesión iniciada como: {user.displayName} - {user.email} (
          <Link onClick={logout} to="/">
            Salir
          </Link>
          )
        </p>
        <div className="row">
          <div className="col-md">
            <h3>Cambio de Contraseña</h3>
            <Form onSubmit={handleSubmit}>
              <Form.Group controlId="password">
                <Form.Label>Contraseña Actual</Form.Label>
                <Form.Control disabled={false} type="password" required placeholder="Tu actual contraseña" />
                <Form.Text className="text-muted">
                  {error
                    ? <span style={{ color: 'red' }}>{error}</span>
                    : ''}
                </Form.Text>
              </Form.Group>
              <Form.Group controlId="newPassword">
                <Form.Label>Contraseña Nueva</Form.Label>
                <Form.Control disabled={false} type="password" required placeholder="Tu nueva contraseña" />
                <Form.Text className="text-muted">
                  {newPassError
                    ? <span style={{ color: 'red' }}>{newPassError}</span>
                    : ''}
                </Form.Text>
              </Form.Group>
              <Form.Group controlId="repitePassword">
                <Form.Label>Vuelve a escribir la nueva contraseña</Form.Label>
                <Form.Control disabled={false} type="password" required placeholder="Repite tu nueva contraseña" />
                <Form.Text className="text-muted">
                  {matchError
                    ? <span style={{ color: 'red' }}>{matchError}</span>
                    : ''}
                </Form.Text>
              </Form.Group>
              <p>Nota: No es necesario que uses la misma contraseña que en el foro.</p>

              <Button disabled={false} variant="primary" type="submit">
                Cambiar Contraseña
              </Button>
            </Form>
          </div>
          <div className="col-md">

          </div>
        </div>

        <br />
        <br />
      </div>
      <Footer />
    </Fragment>
  );

  else return <Fragment>
    <WikiNavBar />
    <div style={{ marginTop: 55 }} />
    <div className="container">

      <h2>No Autorizado</h2>
      <p>Tu cuenta aún no ha sido activada. Sé paciente.</p>
    </div>
  </Fragment>
};

export default MiCuentaPage;
